import { render } from "./RevenuesReportDetails.vue?vue&type=template&id=916b3bd0&scoped=true"
import script from "./RevenuesReportDetails.vue?vue&type=script&lang=js"
export * from "./RevenuesReportDetails.vue?vue&type=script&lang=js"

import "./RevenuesReportDetails.vue?vue&type=style&index=0&id=916b3bd0&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916b3bd0"]])

export default __exports__